import { aesGcmEncryptBuffer } from './aes';
import { generateDek, wrapDek } from './dek';
import { arrayBufferToBase64, getWebCrypto } from './encoding';

export interface EncryptedFileResult {
  ciphertext: ArrayBuffer;
  fileIv: string;
  wrappedDek: string;
  checksumSha256: string;
}

async function sha256Hex(buffer: ArrayBuffer): Promise<string> {
  const cryptoApi = getWebCrypto();
  const digest = await cryptoApi.subtle.digest('SHA-256', buffer);
  const bytes = new Uint8Array(digest);

  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
}

export async function encryptFile(file: File, publicKeyPem: string): Promise<EncryptedFileResult> {
  const dek = await generateDek();
  const plaintext = await file.arrayBuffer();
  const { ciphertext, iv } = await aesGcmEncryptBuffer(plaintext, dek);
  const wrappedDek = await wrapDek(dek, publicKeyPem);
  const checksumSha256 = await sha256Hex(ciphertext);

  return {
    ciphertext,
    fileIv: iv,
    wrappedDek,
    checksumSha256,
  };
}

export async function checksumSha256(buffer: ArrayBuffer): Promise<string> {
  return sha256Hex(buffer);
}

export function ciphertextToBase64(ciphertext: ArrayBuffer): string {
  return arrayBufferToBase64(ciphertext);
}
